import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconWayFinder = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <g>
            <path d="M15,0.8c-4.3,0-7.7,3.4-7.7,7.6c0,2.4,0.9,4.3,1.2,4.8c0.1,0.2,0.3,0.6,0.5,0.9c1.3,2.5,3.9,7,4.8,14
				c0.1,0.5,0.5,1,1.1,1c0.5,0,1-0.4,1.1-1c0.9-7,3.5-11.6,4.8-14c0.2-0.4,0.4-0.7,0.5-0.9c0.4-0.7,1.2-2.7,1.2-4.8
				C22.6,4.3,19.3,0.8,15,0.8z M20.4,12.8c-1.1,2.1-4.4,7.1-5.4,15.3c-1.1-8.2-4.4-13.2-5.4-15.3c-0.5-1-1-2.7-1-4.4
				c0-3.6,2.9-6.6,6.6-6.6s6.6,2.9,6.6,6.6C21.6,10.2,21,11.8,20.4,12.8z M15,4.1c-2.5,0-4.4,1.9-4.4,4.4c0,2.4,1.9,4.4,4.4,4.4
				s4.4-1.9,4.4-4.4S17.4,4.1,15,4.1z M15,11.7c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3S16.8,11.7,15,11.7z"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );

};

IconWayFinder.displayName = 'IconWayFinder';
IconWayFinder.muiName = 'SvgIcon';

export default IconWayFinder;



// WEBPACK FOOTER //
// ./src/components/Icons/IconWayFinder.js